export const dishes = [
  {
    _id: "1",
    category: "SALAD",
    subcategory: "Meat salad",
    name: "Special beef salad",
    serving: "150",
    price: 4.5,
    calories: 200,
    description: "Beef, salad",
    composition: "",
    pictureURL:
      "https://www.foodiesfeed.com/wp-content/uploads/2015/05/green-salad-with-beef-steak-cuts-413x555.jpg",
    __v: 0
  },
  {
    _id: "2",
    category: "SALAD",
    subcategory: "Meat salad",
    name: "Chicken salad",
    serving: "150",
    price: 4.5,
    calories: 200,
    description: "",
    composition: "",
    pictureURL:
      "https://www.foodiesfeed.com/wp-content/uploads/2017/07/spinach-pomegranate-and-chicken-salad-413x275.jpg",
    __v: 0
  },
  {
    _id: "3",
    category: "SALAD",
    subcategory: "Vegetarian salad",
    name: "Tomato salad",
    serving: "150",
    price: 3,
    calories: 100,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/4989069/pexels-photo-4989069.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    __v: 0
  },
  {
    _id: "4",
    category: "SALAD",
    subcategory: "Vegetarian salad",
    name: "Cucumber salad",
    serving: "150",
    price: 3,
    calories: 100,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/2862154/pexels-photo-2862154.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260",
    __v: 0
  },
  {
    _id: "5",
    category: "MAIN",
    subcategory: "Burgers",
    name: "Special beef burger",
    serving: "400",
    price: 10,
    calories: 500,
    description: "Our very special burger",
    composition: "Beef, dough, milk, green salad",
    pictureURL:
      "https://images.pexels.com/photos/1633578/pexels-photo-1633578.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "6",
    category: "MAIN",
    subcategory: "Burgers",
    name: "Special chicken burger",
    serving: "350",
    price: 9,
    calories: 400,
    description: "Our very special burger",
    composition: "Chicken, dough, milk, green salad",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "7",
    category: "MAIN",
    subcategory: "Steaks",
    name: "Beef steak",
    serving: "400",
    price: 14,
    calories: 500,
    description: "Our very special burger",
    composition: "Beef",
    pictureURL:
      "https://images.pexels.com/photos/1251208/pexels-photo-1251208.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "8",
    category: "SIDE DISHES",
    subcategory: "Potatoes",
    name: "French fries",
    serving: "150",
    price: 3,
    calories: null,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "9",
    category: "SIDE DISHES",
    subcategory: "Potatoes",
    name: "Baked potatoes",
    serving: "150",
    price: 3,
    calories: null,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "10",
    category: "SIDE DISHES",
    subcategory: "Mushrooms",
    name: "Fried mushrooms",
    serving: "150",
    price: 4,
    calories: null,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/4661880/pexels-photo-4661880.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "11",
    category: "DESSERTS",
    subcategory: "Pastry",
    name: "Special home-made cookies",
    serving: "150",
    price: 3,
    calories: 500,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "12",
    category: "DESSERTS",
    subcategory: "Ice cream",
    name: "Special vanilla ice cream",
    serving: "150",
    price: 10,
    calories: 500,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/3625371/pexels-photo-3625371.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "13",
    category: "BEVERAGES",
    subcategory: "Non-alcoholic",
    name: "Green tea",
    serving: "150",
    price: 3,
    calories: 500,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/1417945/pexels-photo-1417945.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "14",
    category: "BEVERAGES",
    subcategory: "Non-alcoholic",
    name: "Soda",
    serving: "150",
    price: 3,
    calories: 500,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/104509/pexels-photo-104509.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "15",
    category: "BEVERAGES",
    subcategory: "Alcoholic",
    name: "Whiskey",
    serving: "100",
    price: 8,
    calories: 500,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/51365/drink-alcohol-cup-whiskey-51365.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "16",
    category: "BEVERAGES",
    subcategory: "Alcoholic",
    name: "Wine",
    serving: "300",
    price: 10,
    calories: 500,
    description: "",
    composition: "",
    pictureURL:
      "https://images.pexels.com/photos/4004421/pexels-photo-4004421.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
    __v: 0
  },
  {
    _id: "17",
    category: "OTHER",
    subcategory: "",
    name: "Disposable tableware",
    serving: "1",
    price: 1,
    calories: null,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "18",
    category: "SPECIAL",
    subcategory: "",
    name: "Roasted whole pig",
    serving: "4000",
    price: 150,
    calories: null,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  },
  {
    _id: "19",
    category: "SPECIAL",
    subcategory: "",
    name: "Baked duck",
    serving: "2000",
    price: 90,
    calories: null,
    description: "",
    composition: "",
    pictureURL: "",
    __v: 0
  }
];
